var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { attrs: { cols: "12", align: "middle" } },
            [
              _c(
                "v-card",
                { attrs: { flat: "" } },
                [
                  _c(
                    "v-row",
                    [_c("v-col", [_c("h1", [_vm._v("Error Page!")])])],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-card-text",
                    [
                      _c(
                        "v-row",
                        [
                          _c(
                            "v-col",
                            { attrs: { cols: "12" } },
                            [
                              _c("v-img", {
                                attrs: {
                                  "lazy-src":
                                    "https://picsum.photos/id/11/10/6",
                                  "max-height": "550",
                                  "max-width": "650",
                                  src: "/content/images/404.svg",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-row",
                        [
                          _c("v-col", { attrs: { cols: "12" } }, [
                            _vm.errorMessage
                              ? _c("div", [
                                  _c(
                                    "div",
                                    { staticClass: "alert alert-danger" },
                                    [_vm._v(_vm._s(_vm.errorMessage))]
                                  ),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c("div", { attrs: { color: "secondary" } }, [
                              _c("h1", { staticClass: "font-weight-black" }, [
                                _c(
                                  "strong",
                                  { staticStyle: { color: "#FF4800" } },
                                  [_vm._v("Oops!")]
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _vm.error403
                              ? _c("div", { staticClass: "mt-2" }, [
                                  _c(
                                    "h2",
                                    { staticClass: "font-weight-medium" },
                                    [
                                      _vm._v(
                                        "You are not authorized to access this page."
                                      ),
                                    ]
                                  ),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.error404
                              ? _c("div", { staticClass: "mt-2" }, [
                                  _c(
                                    "h2",
                                    { staticClass: "font-weight-medium" },
                                    [
                                      _vm._v(
                                        "Hmm... The page you requested was not found"
                                      ),
                                    ]
                                  ),
                                ])
                              : _vm._e(),
                          ]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-row",
                        { staticClass: "mt-4" },
                        [
                          _c(
                            "v-col",
                            [
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    rounded: "",
                                    small: "",
                                    color: "secondary",
                                    dark: "",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.previousState()
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                Back to safety\n              "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }